import script from "./OrganizationFilterForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationFilterForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationFilterForm.vue?vue&type=style&index=0&id=4ab23de2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab23de2"]])

export default __exports__